import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleCreatorAssigned } from "./types/task-notification.types";
import { getTitleAssignerString } from "./utils/task-notification-title";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorAssignedProps extends ComponentNotificationTitleCreatorAssigned {
  read: boolean;
}
export const TaskNotificationTitleCreatorAssigned = ({
  props: { assignedBy },
  read,
}: TaskNotificationTitleCreatorAssignedProps) => {
  const { t } = useTranslation();
  const assignedByString = getTitleAssignerString(assignedBy);
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("hasReassignedTaskCreatedByYouString", {
        assignedBy: assignedByString,
      })}
    </div>
  );
};
